module.exports = "<div class=\"js-dropdown-region dev-mention-editor__dropdown-region\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/mentionEditor.hbs
// module id = 689
// module chunks = 0